// Select the button that opens the modal
const openButton = document.querySelector('.gant-store-select__button');

// Add click event listener to open the modal
if (openButton) {
  openButton.addEventListener('click', () => {
    console.log('Modal opened');
    const overlayEl = document.getElementById('store-select-overlay');
    if (overlayEl) {
      overlayEl.classList.add('show');
    }
    // Lock background scroll while modal is open
  });
}

// Select the overlay or close button
const closeButton = document.querySelector('.store-select__close');

// Add click event listener to close the modal
if (closeButton) {
  closeButton.addEventListener('click', () => {
    console.log('Modal closed');
    const overlayEl = document.getElementById('store-select-overlay');
    if (overlayEl) {
      overlayEl.classList.remove('show');
    }
  });
}

// Optionally, close the modal when clicking outside of it
const overlay = document.getElementById('store-select-overlay');
if (overlay) {
  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) {
      overlay.classList.remove('show');
    }
  });
}

// function setupAccordion() {
//     if (window.innerWidth < 1024) {
//         document.querySelectorAll('.accordion-toggle').forEach((button) => {
//             button.addEventListener('click', () => {
//                 // Find the closest parent with the class 'footer-block' and then find the 'accordion-content' within it
//                 const content = button.closest('.footer-block').querySelector('.accordion-content');
//                 if (content) {
//                     content.classList.toggle('active');
//                     // Toggle the icon
//                     button.classList.toggle('active');
//                     button.querySelector('.accordion__item-header').classList.toggle('active');
//                 }
//             });
//         });
//     }
// }

// // Run on page load
// setupAccordion();

// // Re-run on window resize
// window.addEventListener('resize', setupAccordion);
